import { jsx as _jsx } from "react/jsx-runtime";
// S2 (P5 parity F1-A): workspace order FORM — y hệt single dock ticket.
// Resolve binding theo chartId (pattern ActiveChartPaperPanel: get + D8
// subscribe); render TradingDockPanel presentational (SSOT với single).
// Không binding (late-register) → null để host disabled tab.
import { useEffect, useState } from "react";
import { TradingDockPanel } from "./TradingDockPanel";
import { getPaperPanelBinding, usePaperPanelBinding } from "../context/PaperPanelRegistry";
import { resolveMarketProfile } from "../../../lib/core/trading/MarketRules";
export function RegistryTradingDockPanel({ chartId, lastPrice, disabled, isReplayMode, canUseReplayTrading, canUseAdvancedOrders }) {
    // Re-render khi binding đến/mất (late registration) — D8, mirror ActiveChartPaperPanel.
    usePaperPanelBinding(chartId);
    const [, setRev] = useState(0);
    const binding = getPaperPanelBinding(chartId);
    useEffect(() => binding?.subscribe(() => setRev((v) => v + 1)), [binding]);
    if (!binding)
        return null;
    const snapshot = binding.getSnapshot();
    const account = snapshot.account;
    return (_jsx(TradingDockPanel, { symbol: binding.symbol, lastPrice: lastPrice, disabled: disabled ?? !snapshot.tradingEnabled, isReplayMode: isReplayMode, canUseReplayTrading: canUseReplayTrading, canUseAdvancedOrders: canUseAdvancedOrders, rules: resolveMarketProfile(binding.symbol), account: { equity: account.equity, freeMargin: account.freeMargin, buyingPower: account.buyingPower }, currentPosition: snapshot.positions.find((p) => p.symbol === binding.symbol) ?? null, onSubmit: (order) => {
            binding.placeOrder({ ...order, symbol: binding.symbol });
        } }));
}
